export const environment = {
  production: false,
  appUrl: 'http://localhost:4200',
  apiUrl: 'https://jbrpyh2pwp.us-east-2.awsapprunner.com/api',
};